import React, { useState } from 'react';
import { Grid, TextField, Button, Typography } from '@material-ui/core';

import axios from 'axios';
import { BASE_URL } from '../../constants';

const AdminDashboard = (props) => {
	const { bearerToken } = props;
    console.log(bearerToken);
	const [imageName, setImageName] = useState('');
	const [imageUrl, setImageUrl] = useState('');
	const [sliderImages, setSliderImages] = useState([]);
	const handleImageAdd = () => {
		setSliderImages([...sliderImages, { text: imageName, image: imageUrl }]);
		setImageName('');
		setImageUrl('');
	};
	const handleSubmit = () => {
		if (sliderImages.length > 0) {
			axios
				.put(
					`${BASE_URL}manage/admin/home/slider`,
					{
						slider: sliderImages,
					},
					{
						headers: {
							Authorization: bearerToken,
						},
					}
				)
				.then((response) => {
					console.log(response);
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};
	return (
		<div className='AdminDashboard' style={{ textAlign: 'center' }}>
			<Grid container>
				<h1>Add Slider Images</h1>
				<Grid item xs={12}>
					<form
						onSubmit={handleImageAdd}
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							margin: '0px auto',
							textAlign: 'center',
						}}
					>
						<TextField
							label='Image Name'
							variant='outlined'
							style={{ margin: '20px' }}
							value={imageName}
							onChange={(event) => {
								setImageName(event.target.value);
							}}
						/>
						<TextField
							label='Image URL'
							variant='outlined'
							style={{ margin: '20px', width: '70%' }}
							value={imageUrl}
							onChange={(event) => {
								setImageUrl(event.target.value);
							}}
						/>
						<Button variant='contained' onClick={handleImageAdd}>
							Add the image
						</Button>
					</form>
				</Grid>
				{sliderImages.map((anImage) => (
					<Grid item xs={12}>
						<TextField
							label='Image Name'
							variant='outlined'
							style={{ margin: '20px' }}
							value={anImage.text}
							readonly
						/>
						<TextField
							label='Image URL'
							variant='outlined'
							value={anImage.image}
							style={{ margin: '20px', width: '70%' }}
							readonly
						/>
					</Grid>
				))}
				<Grid item xs={12}>
					<Button variant='contained' color='primary' onClick={handleSubmit}>
						Submit Slider Images
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default AdminDashboard;
